import { render } from "./BrandMiss7Mama.vue?vue&type=template&id=e148c5f8"
import script from "./BrandMiss7Mama.vue?vue&type=script&lang=ts"
export * from "./BrandMiss7Mama.vue?vue&type=script&lang=ts"

import "./BrandMiss7Mama.vue?vue&type=style&index=0&id=e148c5f8&lang=scss"
script.render = render

export default script